import React from 'react'
import { Instagram, Tiktok, Youtube, Pinterest, Linkedin } from 'react-bootstrap-icons'
import axiosService from '../../../utils/AxiosService'
import { toastError } from '../../FormComponents/Toasts'
import KpiMetricsRow from '../../ProjectManager/Campaigns/CampaignsBrowseParts/KpiMetricsRow'
import { CLIENT_PAGE_GUTTER } from '../../ProjectManager/Campaigns/CampaignsBrowseParts/clientPageLayout'

const PLATFORM_ICONS = [
  { key: 'instagram', Icon: Instagram, className: 'dark:text-pink-400' },
  { key: 'tiktok', Icon: Tiktok, className: 'dark:text-white' },
  { key: 'youtube', Icon: Youtube, className: 'dark:text-red-400' },
  { key: 'pinterest', Icon: Pinterest, className: 'dark:text-white' },
  { key: 'linkedin', Icon: Linkedin, className: 'dark:text-rb-linkedin' },
]

// No edit menu, no delete (client-facing) - but opens the same read-only view a campaign share link shows.
function SummaryCampaignCard({ campaign, onOpen }) {
  return (
    <div
      className="h-[144px] flex flex-col justify-between rounded-lg border-1 border-rb-lighter-grey bg-white p-3 hover:cursor-pointer hover:bg-rb-grey dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:hover:bg-rb-dark-mode-lighter"
      onClick={() => onOpen(campaign)}
    >
      <div className="flex items-center">
        <span
          className="flex h-10 w-10 items-center justify-center rounded-lg text-lg"
          style={{ backgroundColor: campaign.theme_color || '#6b7280' }}
        >
          <span className="text-white">{campaign.name.slice(0, 2).toUpperCase()}</span>
        </span>
        <div className="min-w-0 pl-3">
          <h4 className="w-full truncate text-md font-bold dark:text-white">{campaign.name}</h4>
          {campaign.folder_name && <p className="rb-text-muted truncate text-sm">{campaign.folder_name}</p>}
        </div>
      </div>

      <div className="flex items-center">
        {PLATFORM_ICONS.filter(({ key }) => campaign.platforms?.includes(key)).map(({ key, Icon, className }) => (
          <span
            key={key}
            className={`ml-2 flex h-6 w-6 items-center justify-center rounded-full bg-rb-grey text-black first:ml-0 dark:bg-rb-dark-mode-lighter ${className}`}
          >
            <Icon />
          </span>
        ))}
      </div>

      <div className="flex items-center justify-between">
        <span
          className={`rounded-full px-2 py-1 ${
            campaign.is_finished
              ? 'bg-rb-lite-grey rb-text-secondary dark:bg-rb-dark-mode-lighter'
              : 'bg-rb-soft-green text-rb-green dark:bg-rb-green/20 dark:text-rb-green'
          }`}
        >
          {campaign.is_finished ? 'Finished' : 'Active'}
        </span>
        {campaign.project_number && (
          <span className="rounded-full bg-rb-grey px-2 py-1 dark:bg-rb-dark-mode-lighter dark:text-white">
            {campaign.project_number}
          </span>
        )}
      </div>
    </div>
  )
}

export default function SharedClientSummaryTab({ campaigns }) {
  const openCampaign = (campaign) => {
    // Open in a new tab so the client's Summary view stays in place behind it.
    axiosService.post(`/api/advertiser/client_share/campaigns/${campaign.id}/open`)
      .then(({ id }) => window.open(`/advertiser/campaign_share/${id}`, '_blank', 'noopener,noreferrer'))
      .catch(() => toastError('Could not open campaign'))
  }

  return (
    <div className="h-full w-full overflow-y-auto pb-8">
      <div className={`${CLIENT_PAGE_GUTTER} py-6`}>
        <KpiMetricsRow campaigns={campaigns} budgetTitle="Total Budget" layout="grid" />
      </div>
      <div className={CLIENT_PAGE_GUTTER}>
        <h2 className="mb-3 text-lg font-bold dark:text-white">Campaigns</h2>
        <div className="grid grid-cols-3 gap-5">
          {campaigns.map((campaign) => (
            <SummaryCampaignCard key={campaign.id} campaign={campaign} onOpen={openCampaign} />
          ))}
        </div>
      </div>
    </div>
  )
}
